import React from 'react';
interface ReceiptHeaderProps {
  companyInfo: {
    name: string;
    logo: string;
    address: string;
    contact: string;
  };
  receiptNo: string;
  receiptDate: string;
  bookingRef: string;
  gstRegNo: string;
  tourCode: string;
  paymentMethod: string;
  collectedBy: string;
  printedBy: string;
}
export function ReceiptHeader({
  companyInfo,
  receiptNo,
  receiptDate,
  bookingRef,
  gstRegNo,
  tourCode,
  paymentMethod,
  collectedBy,
  printedBy
}: ReceiptHeaderProps) {
  return <div className="mb-8" data-id="element-1166">
      <div className="flex justify-between items-start mb-4" data-id="element-1167">
        {/* Left: Logo */}
        <div data-id="element-1168">
          <img src={companyInfo.logo} alt={companyInfo.name} className="h-14 object-contain object-left" data-id="element-1169" />
        </div>

        {/* Right: Company Address */}
        <div className="text-right" data-id="element-1170">
          <h1 className="text-sm text-neutral-900 mb-1" data-id="element-1171">{companyInfo.name}</h1>
          <div className="text-[10px] text-neutral-500 space-y-0.5 leading-relaxed whitespace-pre-line" data-id="element-1172">
            {companyInfo.address}
          </div>
          <div className="text-[10px] text-neutral-500 mt-1" data-id="element-1173">
            {companyInfo.contact}
          </div>
        </div>
      </div>

      {/* Centered Title */}
      <h2 className="text-lg font-bold text-neutral-900 mb-2 tracking-tight text-center" data-id="element-1174">
        OFFICIAL RECEIPT
      </h2>

      {/* Receipt Details Box */}
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-3 mb-4" data-id="element-1175">
        {/* Two Column Grid - Reorganized */}
        <div className="grid grid-cols-2 gap-x-8 gap-y-1.5" data-id="element-1176">
          {/* Left Column */}
          <div className="space-y-1.5" data-id="element-1177">
            <div className="flex justify-between" data-id="element-1178">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1179">
                Receipt No.:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-1180">
                {receiptNo}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-1181">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1182">
                Receipt Date:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1183">{receiptDate}</span>
            </div>
            <div className="flex justify-between" data-id="element-1184">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1185">
                Payment Method:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1186">{paymentMethod}</span>
            </div>
            <div className="flex justify-between" data-id="element-1187">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1188">
                GST Reg. No.:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1189">{gstRegNo}</span>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-1.5" data-id="element-1190">
            <div className="flex justify-between" data-id="element-1191">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1192">
                Booking Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1193">{bookingRef}</span>
            </div>
            <div className="flex justify-between" data-id="element-1194">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1195">
                Tour Code:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1196">{tourCode}</span>
            </div>
            <div className="flex justify-between" data-id="element-1197">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1198">
                Collected By:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-1199">
                {collectedBy}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-1200">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1201">
                Printed By:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1202">{printedBy}</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}